import IAuthority from "interfaces/models/IAuthority";
import IClaim from "interfaces/responses/IClaimWhitespace";

const mapWhitespaceClaimToAuthority = (claim : IClaim) : IAuthority => {
  const authority : IAuthority = {
    authorityId: claim.id,
    authorityName: claim.displayName
  };

  return authority;
};

export { mapWhitespaceClaimToAuthority };
